<template>
  <!-- This is the starting point to get to the report -->
  <div>
    <div class="d-flex justify-center align-content-center" v-if="reportLoaded && !report">
      No report found.
    </div>
    <ReportSummary v-if="reportLoaded && report" :report="report">
      <div>
        <v-list dense outlined rounded class="mt-2 pa-2 record--list">
          <div class="text-xl-start">Official Report Record{{ recordLinks.length > 1 ? 's' : '' }}</div>
          <!-- @TODO: remove the false test after we have removed all report user data and the html view  -->
          <v-list-item v-if="report.user_data && false">
            <v-list-item-icon>
              <v-icon color="error">picture_as_pdf</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <router-link :to="{name: 'campaign-finance-report', params: { report_number: report_id }}"
                           target="_blank">
                <v-list-item-title>View Full Report</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
              v-for="(reportLink, i) in recordLinks"
              :key="i"
          >
            <v-list-item-icon>
              <v-icon color="error">picture_as_pdf</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <a :href="reportLink.url" target="_blank">
                <v-list-item-title>{{ reportLink.description }}</v-list-item-title>
              </a>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </ReportSummary>
  </div>
</template>

<script>

import socrata from '@/SocrataDataService';
import {publicApp as app} from '@/main';
import ReportSummary from '@/components/ReportSummary';
import socrataDataService from '@/SocrataDataService'
import filters from '@/filters'

const buildImageUrl = (report_id) => {
  return `http://web.pdc.wa.gov/rptimg/default.aspx?batchnumber=${report_id}`
}

export default {
  name: "ReportOverview",
  components: {
    ReportSummary
  },
  data() {
    return {
      report: null,
      reportLoaded: false,
      recordLinks: [],
      report_id: "",
    }
  },
  created() {
    this.loadReport(this.$route.params.report_number);
  },
  methods: {
    downloadPdf() {
      const report = {...this.report, user_data: {...this.report.user_data}}
      switch (this.report.report_type) {
        case 'C3':
          report.user_data.contributions = report.user_data.contributions.map(cont => {
            const contact = report.user_data.contacts.find(contact => cont.contact_key === contact.contact_key)
            return {...cont, contact}
          })
          app.$container.pdf.C3.make(report);
          break;
        case 'C4':
          app.$container.pdf.C4.make(report);
          break;
      }
    },
    async loadReport(report_number) {
      this.report_id = report_number;
      this.report = await socrata.getReport('REPORTING_HISTORY', {report_number});
      if (!this.report) {
        this.reportLoaded = true;
        return;
      }
      this.report.url = buildImageUrl(this.report.report_number)
      this.report.metadata = this.report.metadata ? JSON.parse(this.report.metadata) : [];
      this.report.attachments = this.report.attachments ? JSON.parse(this.report.attachments) : [];
      const {user_data} = await app.$container.dataService.getReportMetadata(this.report.report_number);
      // @TODO: remove the true condition when we have deleted user_data when we go live with 1.440.
      if (!user_data || true) {
        if (parseInt(report_number) >= 1000000000) {
          this.getPaperFiledRecords();
        } else {
          const {origin, receipt_date} = this.report;
          const url = this.report.report_number ? buildImageUrl(this.report.report_number) : null;
          const description = this.report.report_number ? `${origin} - ${receipt_date}` + ' - View Document' : 'Invalid document request';
          this.recordLinks = [{description, url}];
        }
      } else {
        this.report.user_data = user_data;
      }
      this.reportLoaded = true;
    },
    getPaperFiledRecords() {
      socrataDataService.getRecords('IMAGED_DOCUMENTS', {
        filer_id: `${this.report.filer_id}`,
        election_year: `${this.report.election_year}`,
        origin: this.report.origin,
        period_start: `${this.report.report_from || ''}`,
        period_end: `${this.report.report_through || ''}`
      }).then(data => {
        const records = data.data.map(({url, receipt_date, document_description}) => ({
          url: url.url,
          description: `${document_description} - ${filters.filters.formatDate(receipt_date)}`
        }));
        this.recordLinks = [...this.recordLinks, ...records];
      });
    },
  },

}
</script>

<style scoped>
.record--list {
  border: 1px solid rgba(0, 0, 0, 0.2);
  margin-top: 20px;
  padding: 10px;
}
</style>